// https://chartjs-plugin-datalabels.netlify.app/
// https://www.chartjs.org/docs/master/
import React, { useEffect, useState, useRef } from "react";
import { Bar } from "react-chartjs-2";
import GetAppIcon from '@material-ui/icons/GetApp';
import ChartDataLabels from "chartjs-plugin-datalabels";
import { colors } from "../../helpers/colors";
import { defaultTextImage } from "../../configuration/variables";

const medias = {
    lx: "12",
    md: "12",
    xs: "12",
};

const VerticalChart = ({
    mediaQueries = medias,
    subTitle = "Probando",
    chartComment='',
    dataChart = [],
}) => {
    const { lx, md, xs } = mediaQueries;
    const columnsMedia = `col-xl-${lx} col-md-${md} col-xs-${xs} mb-4`;
    const imageResolution = { width: 1366, height: 768 }

    const chartRef = useRef(null);
    const chartImageRef = useRef(null);
    const imageRef = useRef(null);
    const canvasRef = useRef(null);
    const [imageUrl, setImageUrl] = useState('');
    const [chartValues, setChartValues] = useState({
        positives: [],
        negatives: [],
        netos: [],
        headers: [],
    });

    const plugin = {
        beforeDraw: (chart) => {
            const ctx = chart.canvas.getContext('2d');
            ctx.save();
            ctx.globalCompositeOperation = 'destination-over';
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, chart.width, chart.height);
            ctx.restore();
        }
    };

    const dataBar = {
        labels: chartValues.headers,
        datasets: [
            {
                label: "% Nota 6 a 7",
                data: chartValues.positives,
                backgroundColor: colors.azul,
                datalabels: {
                    anchor: "end",
                    align: "end",
                    color: colors.azul,
                },
                stack: "Stack 0",
                type: "bar",
                // stack: 'combined',
                order: 1,
            },
            {
                label: "% Nota 1 a 4",
                data: chartValues.negatives,
                backgroundColor: colors.celeste,
                datalabels: {
                    anchor: "start",
                    align: "start",
                    color: colors.celeste,
                },
                stack: "Stack 0",
                type: "bar",
                // stack: 'combined',
                order: 1,
            },
            {
                label: "% Neto",
                data: chartValues.netos,
                backgroundColor: colors.amarillo,
                borderColor: colors.amarillo,
                datalabels: {
                    anchor: "end",
                    align: "end",
                    color: "#fff",
                },
                type: "line",
                // stack: 'combined',
                order: 0,
            },
        ],
    }

    const optionsBar = {
        maintainAspectRatio: false,
        scales: {
            x: {
                stacked: true,
                min: -100,
                max: 100,
            },
            y: {
                stacked: true,
                min: -100,
                max: 100,
            },
        },
    }

    const downloadChartImage = () => {
        const base64Chart = chartImageRef.current.toBase64Image();
        setImageUrl(base64Chart);
    };

    useEffect(() => {
        const headers = [];
        const positives = [];
        const negatives = [];
        const netos = [];

        dataChart.forEach((item) => {
            const [label, positive, negative, neto] = Object.values(item);
            headers.push(label);
            positives.push(Math.round(positive));
            negatives.push(Math.round(negative));
            netos.push(Math.round(neto));
        });

        setChartValues({
            positives: positives,
            negatives: negatives,
            netos: netos,
            headers: headers,
        });
    }, [dataChart]);

    useEffect(() => {
        if(imageUrl){
            // generar la imagen con el texto
            const currentCanvas = canvasRef.current;
            const ctx = currentCanvas.getContext("2d");
            setTimeout(() => { 
                ctx.drawImage(imageRef.current, 0, 20, imageResolution.width, imageResolution.height);
                // añadir texto a la imagen.
                ctx.font = "11px Arial";
                ctx.textAlign = "center";
                ctx.fillText(defaultTextImage, imageResolution.width / 2, 15); 

                // fonto de la imagen.
                ctx.globalCompositeOperation = "destination-over";
                ctx.fillStyle = '#fff'; // <- background color
                ctx.fillRect(0, 0, imageResolution.width, imageResolution.height);

                // descagr la imagen
                let a = document.createElement("a");
                let url = currentCanvas.toDataURL("image/png");
                a.href = url;
                a.target = "_blank";
                a.download = "grafico.png";
                // Trigger the download
                a.click();

                setImageUrl('');
            }, 500);
        }
    }, [ imageUrl ])

    return (
        <div className={columnsMedia}>
            <div className="div-char h-100 mt-2">
                <div className="d-flex justify-content-between align-items-center">
                    <h6>{subTitle}</h6>
                    <button
                        className="btn btn-sm fs-3 ml-2"
                        title="Descargar gráfico (png)"
                        style={{ background: '#53565A', color: 'white' }}
                        onClick={downloadChartImage}
                    >
                        <GetAppIcon/>
                    </button>
                </div>
                <div style={{ height: "60vh", backgroundColor: 'white' }}>
                    <div style={{ display: 'none' }}>
                        <canvas
                            ref={ canvasRef } 
                            width={ imageResolution.width } 
                            height={ imageResolution.height + 20 } 
                            style={{ backgroundColor: '#00F8' }}    
                        />
                        <img 
                            ref={ imageRef }
                            alt="Gráficos"
                            src={ imageUrl }
                            className="hidden"
                        />
                    </div>

                    <div style={{ position: 'relative', }} >
                        <div style={{ 
                            position: 'absolute', 
                            width: `${imageResolution.width}px`, 
                            height: `${imageResolution.height}px`, 
                            visibility: 'hidden', 
                            left: '-1400px', 
                            bottom: '-100px'
                        }} >
                            <Bar
                                ref={chartImageRef}
                                plugins={[ChartDataLabels, plugin]}
                                data={dataBar}
                                options={optionsBar}
                            />
                        </div>
                    </div>

                    <Bar
                        ref={chartRef}
                        plugins={[ChartDataLabels, plugin]}
                        data={dataBar}
                        options={optionsBar}
                    />
                </div>
                { chartComment && <p className="text-muted mb-0">{chartComment}</p> }
            </div>
        </div>
    );
};

export default VerticalChart;
